import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface BannerState {
  showBanner: boolean
  bannerMessage: string
  buttonText?: string
  buttonUrl?: string
  bannerType?: string
  bannerName?: string
}

export const initialState: BannerState = {
  showBanner: false,
  bannerMessage: '',
}

export const bannerSlice = createSlice({
  name: 'banner',
  initialState,
  reducers: {
    updateShowBanner: (state, action: PayloadAction<boolean>) => {
      state.showBanner = action.payload
    },
    updateBannerMessage: (state, action: PayloadAction<string>) => {
      state.bannerMessage = action.payload
    },
    updateBannerButton: (
      state,
      action: PayloadAction<{ text: string; url: string }>,
    ) => {
      state.buttonText = action.payload.text
      state.buttonUrl = action.payload.url
    },
    updateBannerType: (state, action: PayloadAction<string>) => {
      state.bannerType = action.payload
    },
    updateBannerName: (state, action: PayloadAction<string>) => {
      state.bannerName = action.payload
    },
    resetBanner: (state) => {
      state.showBanner = initialState.showBanner
      state.bannerMessage = initialState.bannerMessage
      state.buttonText = initialState.buttonText
      state.buttonUrl = initialState.buttonUrl
    },
  },
})

export const {
  updateShowBanner,
  updateBannerMessage,
  updateBannerButton,
  resetBanner,
  updateBannerType,
  updateBannerName,
} = bannerSlice.actions
export default bannerSlice.reducer
